<template>
  <div class="swaychat-card-message swaychat-faux" v-if="images.length || files.length">
    <div class="swaychat-card-message-content">
      <ul class="swaychat-card-gallery" v-if="images.length">
        <li v-for="item in images">
            <div class="swaychat-loading-circle" ></div>
        </li>
      </ul>
      <ul class="swaychat-card-list" v-if="files.length">
        <li v-for="item in files">
                <div class="swaychat-card-message-fileinfo">
                    <span class="swaychat-card-message-filename">
                      <i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
                    </span>
                    <span class="swaychat-card-message-filesize">
                      <i></i><i></i>
                    </span>
                </div>
        </li>
      </ul>
    </div>
    <div class="swaychat-card-message-footer">
      <h6>
        <i></i><i></i>
        <i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
        <i></i><i></i><i></i><i></i><i></i><i></i>
      </h6>
    </div>
  </div>
</template>

<script>

export default {
  props: [
    'meta',
    'created_at',
    'from',
    'read'
  ],
  computed: {
    files() {

      let f = []
      let meta = this.meta

      for (let i = 0; i < meta.length; i++) {
        if (meta[i].format_type != 'image' && meta[i].upload == 100 && !meta[i].abort) {
          f.push(meta[i])
        }
      }

      return f
    },
    images() {

      let f = []
      let meta = this.meta

      for (let i = 0; i < meta.length; i++) {
        if (meta[i].format_type == 'image' && meta[i].upload == 100 && !meta[i].abort) {
          f.push(meta[i])
        }
      }


      return f

    },
  }

}

</script>
